import { createContext } from 'react';

export interface ContactMethodsMenuContextType {
  setIsContactsMenuOpen?: (open: boolean) => void;
  setShouldCloseOnOutsideClick?: (shouldClose: boolean) => void;
}

/**
 * This Context provides menu control functions to components under the ContactMethodsMenu.
 */
const ContactMethodsMenuContext = createContext<
  ContactMethodsMenuContextType | undefined
>(undefined);

export default ContactMethodsMenuContext;
